module.exports = __webpack_public_path__ + "static/img/code_kf.10a3a7df.png";